import { BmHttp } from "../utils/Global";

// COBERTURAS-07 -- Cartera por Aseguradora, Cobros y Conciliación.
// Analítico / solo lectura (sin registro de cobros -- ver auditoría §B del
// entregable: no existe en el sistema un modelo confiable de cobros de
// aseguradora).

const buildParams = ({ page, limit, filters = {} }) => ({
    page,
    limit,
    fecha_inicial: filters.fecha_inicial,
    fecha_final: filters.fecha_final,
    idclinica: filters.idclinica,
    aseguradora: filters.aseguradora,
    estado_cartera: filters.estado_cartera,
    estado_contifico: filters.estado_contifico,
    sri_status: filters.sri_status,
    num_documento: filters.num_documento,
    incluir_anuladas: filters.incluir_anuladas,
});

export const GetCarteraAseguradoras = async ({ page = 1, limit = 20, filters }) => {
    try {
        const { data } = await BmHttp().get(`reporte/coberturas/cartera`, { params: buildParams({ page, limit, filters }) });
        return data;
    } catch (error) {
        return error.response?.data || { success: false, data: [], message: "Error de red" };
    }
};

export const GetCarteraPorAseguradora = async ({ filters }) => {
    try {
        const { data } = await BmHttp().get(`reporte/coberturas/cartera/resumen`, { params: buildParams({ filters }) });
        return data;
    } catch (error) {
        return error.response?.data || { success: false, data: [], message: "Error de red" };
    }
};

export const GetCarteraAseguradorasExcel = async ({ filters }) => {
    return BmHttp().get(`reporte/coberturas/cartera/excel`, {
        params: buildParams({ filters }),
        responseType: "blob",
    });
};

export const GetCarteraAseguradorasPdf = async ({ filters }) => {
    return BmHttp().get(`reporte/coberturas/cartera/pdf`, {
        params: buildParams({ filters }),
        responseType: "blob",
    });
};

// COBERTURAS-07B -- ledger real de cobros contra una FAC a aseguradora.
// El backend SIEMPRE recalcula el saldo server-side (nunca se confía uno
// enviado desde aquí) -- ver FCobrosAseguradora.RegistrarCobro.
export const RegistrarCobroAseguradora = async ({ idfactura, valor, fecha_cobro, metodo_pago_id, referencia, observacion }) => {
    try {
        const { data } = await BmHttp().post(`coberturas/cartera/${idfactura}/cobros`, {
            valor,
            fecha_cobro,
            metodo_pago_id,
            referencia,
            observacion,
        });
        return { ok: true, ...data };
    } catch (error) {
        const d = error.response?.data || {};
        return { ok: false, code: d.code || "ERROR", message: d.message || "No se pudo registrar el cobro.", extra: d.extra };
    }
};

export const ListarCobrosAseguradora = async (idfactura) => {
    try {
        const { data } = await BmHttp().get(`coberturas/cartera/${idfactura}/cobros`);
        return data;
    } catch (error) {
        return error.response?.data || { success: false, data: [], message: "Error de red" };
    }
};

export const ReversarCobroAseguradora = async ({ id, motivo }) => {
    try {
        const { data } = await BmHttp().post(`coberturas/cartera/cobros/${id}/reversar`, { motivo });
        return { ok: true, ...data };
    } catch (error) {
        const d = error.response?.data || {};
        return { ok: false, code: d.code || "ERROR", message: d.message || "No se pudo reversar el cobro." };
    }
};
